import "./styles.css";
const urlParams = new URLSearchParams(window.location.search);
//import Plaque from "./Plaque.js";
import DonorBoard from "./DonorBoard.js";
import Auditorium from "./Auditorium.js";
export default function App() {
  return (
    <div className="App">
      {urlParams.get("show") == "donorBoard" ? (
        <DonorBoard scale={1.2} />
      ) : (
        <Auditorium scale={1.0} />
      )}
      {/*
            <Auditorium scale={1.0} />

      <Plaque
        x={10}
        y={20}
        size={"large"}
        text={"Analog Devices"}
        base_size={20}
      />
      <Plaque
        x={10}
        y={220}
        size={"medium"}
        text={"Analog Devices"}
        base_size={20}
      />
      <Plaque
        x={400}
        y={20}
        size={"small-up"}
        text={"Analog Devices"}
        base_size={20}
      />
      <Plaque
        x={400}
        y={220}
        size={"small-down"}
        text={
          <span>
            2024 BOT <br />
            in honor of Nancy Potok
          </span>
        }
        base_size={20}
      />*/}
    </div>
  );
}
